import Accordeon from "./Accordeon"
import "./Accordeon.scss"

export default function FullAccordeon(){

    const qa = [
        {
            "q": "👶 Для якого віку підходять ваші курси?",
            "a": "Наші курси розраховані на діток від 4 до 16 років"
        },
        {
            "q": "💻 В якому форматі проходять заняття?",
            "a": "Заняття проходять онлайн та офлайн в містах Ізмаїл та Білгород-Дністровський"
        },
        {
            "q": "👥 Як проходять заняття - індивідуально чи в групах?",
            "a": "У нас доступні два формати занять: в маленьких групах до 8 діток або індивідуально"
        },
        {
            "q": "🎓 Яка освіта у викладачів?",
            "a": "Наші викладачі мають вищу або неповну вищу педагогічну та фахову освіту у сфері дитячого розвитку. Всі тренери Смартум пройшли сертифікацію у Академії Смартум."
        },
        {
            "q": "❓ Що буде, якщо дитина пропустить заняття?",
            "a": "Ми завжди йдемо назустріч: можна надолужити індивідуально, отримати матеріали, пройти короткий супровід від викладача. Ми за гнучкість, а не за покарання."
        },
        {
            "q": "🧍‍♀️ А якщо моя дитина надто активна / сором’язлива / вперта?",
            "a": "Прекрасно. Ми працюємо з живими дітьми, а не з «ідеальними». Індивідуальність дитини — не проблема, а наш виклик і натхнення. В кожного — свій шлях, і ми готові його пройти разом."
        },
        {
            "q": "🏆 Чи допоможуть ці курси моїй дитині бути успішною в житті?",
            "a": "Ми не обіцяємо, що ваша дитина стане генієм або мільйонером. Але ми розвиваємо ті навички, які сьогодні потрібні більше, ніж просто оцінки — критичне мислення, креативність, впевненість, вміння навчатися та працювати в команді."
        },
    ]

    return(
        <div className="FullAccordeon">
            <div className="wrapper">
                {qa.map((el, index) => {
                    return <Accordeon key={index} title={el.q} body={el.a} />
                })}
            </div>
        </div>
    )
}